module.exports = __webpack_public_path__ + "static/media/advance_sale.dc6a3f85.svg";